export default __webpack_public_path__ + "static/media/Group1108.34e9ea2c.svg";